import { Onix } from './Onix';

export class Lingua {
  tipologia: Onix;
  lingua: Onix;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Lingua.ts